import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as dashboardActions from "src/redux/slices/dashboardSlice";
import BarChart from "src/components/ui/chart/BarChart";
import Skeleton from "src/components/ui/Skeleton";
import { currencyFormatter } from "src/utils/common";

interface TopProductsCardProps {
  days: number;
  periodLabel: string;
  limit?: number;
  enabled?: boolean;
  warehouseId?: string;
}

const TopProductsCard: React.FC<TopProductsCardProps> = ({
  days,
  periodLabel,
  limit = 6,
  enabled = true,
  warehouseId,
}) => {
  const dispatch = useAppDispatch();
  const { tenantTopProducts } = useAppSelector((state) => state.dashboard);

  useEffect(() => {
    if (!enabled) return;
    dispatch(
      dashboardActions.getTenantTopProductsRequest({
        days,
        limit,
        warehouseId: warehouseId || undefined,
      })
    );
  }, [dispatch, days, limit, enabled, warehouseId]);

  if (!enabled) return null;

  const data = tenantTopProducts.data?.data || [];

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-gray-700 dark:text-gray-200">
          Top Selling Products
        </h2>
        <span className="text-xs text-gray-400 dark:text-gray-500">{periodLabel}</span>
      </div>
      {tenantTopProducts.loading ? (
        <Skeleton className="mt-4 h-52 w-full" />
      ) : (
        <BarChart
          data={data}
          dataKey="totalSales"
          xKey="name"
          containerClassName="mt-4 h-52 w-full"
          hideYAxis
          rotateXAxisLabels
          xAxisProps={{ interval: 0 }}
          barColor="#86EFAC"
          barRadius={[8, 8, 8, 8]}
          tooltipFormatter={(value?: number) =>
            currencyFormatter(value || 0, "IN", 2)
          }
        />
      )}
    </div>
  );
};

export default TopProductsCard;
